import { render } from "./ServiceSMS.vue?vue&type=template&id=dd8fb7fc"
import script from "./ServiceSMS.vue?vue&type=script&lang=js"
export * from "./ServiceSMS.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__